<div class="flex flex-col gap-medpace *:gap-medpace">
    <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
        @for (r of createRows; track r) {
            @if (r.type === 'MultiDropDown') {
                <selected-custom-dropdown
                    (inputValueChange)="addInputChange($event)"
                    (applyFilterEvent)="applyFilters()"
                    [labelName]="r.labelText"
                    [data]="r.values"
                    [dataName]="r.filterByName"
                    [setToDefaults]="setToDefaults"
                    [isPatientUrl]="isPatientOverviewUrl() || isPatientAllUrl()"
                    [selectedValues]="r.selectedValues"
                />
            }
            @if (r.type === 'RangeDatePicker') {
                <selected-custom-datepicker
                    (inputValueChange)="addInputChange($event)"
                    [labelName]="r.labelText"
                    [setToDefaults]="setToDefaults"
                    [selectedValues]="r.selectedValues"
                    (applyFilterEvent)="applyFilters()"
                />
            }
        }
    </div>
    <div class="flex flex-row">
        <mds-button
            [id]="'filter-apply-btn'"
            (clickEvent)="onApplyFiltersClicked()"
            variant="tonal"
            color="primary"
            label="Apply filters"
        />
        <mds-button
            [id]="'reset-btn'"
            (clickEvent)="onResetFiltersClicked()"
            variant="tonal"
            color="warn"
            label="Reset"
        />
    </div>
</div>
